import { Typography } from "@suraasa/placebo-ui"
import { useCpat } from "features/Cpat/useCpat"
import { useEffect, useState } from "react"
import Lottie from "react-lottie"
import { useEnrollments } from "utils/hooks/useEnrollments"

export const LoadingReportBanner = () => {
  const { reports } = useCpat()
  const {
    cpat: { throughGSG },
  } = useEnrollments()

  const [confettiAnimation, setConfettiAnimation] = useState<object | null>(
    null
  )
  const [loadingAnimation, setLoadingAnimation] = useState<object | null>(null)

  useEffect(() => {
    import("assets/Cpat/cpat_confetti.json").then(mod =>
      setConfettiAnimation(mod.default)
    )
    import("assets/Cpat/cpat_loading_spinner.json").then(mod =>
      setLoadingAnimation(mod.default)
    )
  }, [])

  // Refetch every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      reports.refetch()
    }, 5000)

    return () => clearInterval(interval)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="relative mb-8 rounded-[16px] bg-[#0B5446]">
      {confettiAnimation && (
        // @ts-expect-error react version issues
        <Lottie
          style={{
            position: "absolute",
            width: "100%",
            margin: 0,
          }}
          isClickToPauseDisabled
          options={{
            loop: true,
            autoplay: true,
            animationData: confettiAnimation,
            rendererSettings: {
              preserveAspectRatio: "xMaxYMax slice",
            },
          }}
        />
      )}

      <div className="p-4">
        <Typography
          variant="smallBody"
          className="mb-2.5 text-[12px] text-white opacity-50"
        >
          ASSESSMENT
        </Typography>
        <div className="mb-2.5 flex flex-wrap gap-0.25">
          <Typography variant={"title2"} className="text-white">
            Good Job!{" "}
          </Typography>
          <Typography variant={"title2"} className="text-white opacity-60">
            You have successfully completed the Assessment.
          </Typography>
        </div>
        {!throughGSG && (
          <div className="flex flex-row items-center gap-1">
            {loadingAnimation && (
              // @ts-expect-error react version issues
              <Lottie
                style={{
                  cursor: "default",
                  width: 26,
                  height: 26,
                  margin: 0,
                }}
                isClickToPauseDisabled
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: loadingAnimation,
                }}
              />
            )}
            <Typography variant="strong" className="text-[#F2D16A]">
              Generating Report. Hang Tight!
            </Typography>
          </div>
        )}
      </div>
    </div>
  )
}
